import React from 'react';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { DateRangePicker } from 'react-date-range';
import {
    Col,
    Row, Input, Button
} from 'reactstrap';
import moment from 'moment';
import { startOfMonth, addMonths, endOfMonth, startOfYear, addYears, endOfYear } from 'date-fns';

const DateRangePickerComp = (props) => {

    const todayDate = moment().subtract(1, 'day').toDate();
    const ref = React.useRef(null);
    const [openDatePicker, setOpenDatePicker] = React.useState(false);
    const [rangeSelection, setRangeSelection] = React.useState(null);


    React.useEffect(() => {
        if (props.defaultRange) {
            setRangeSelection(props.defaultRange);
        }
    }, [props.defaultRange])

    const [dateString, setDateString] = React.useState('');

    const compareRange = (staticRange) => {
        return (moment(rangeSelection.startDate).format('MM-DD-YYYY') === moment(staticRange.startDate).format('MM-DD-YYYY') && moment(rangeSelection.endDate).format('MM-DD-YYYY') === moment(staticRange.endDate).format('MM-DD-YYYY')) ? true : false;
    }
    const getDateRanges = () => {
        const ranges = [
            {
                label: 'Today',
                range: () => ({
                    startDate: moment().toDate(),
                    endDate: moment().toDate(),
                    key: 'selection'
                }),
                isSelected() {
                    return compareRange(this.range());
                },

            },
            {
                label: 'Last 7 days',
                range: () => ({
                    startDate: moment().subtract(7, 'd').toDate(),
                    endDate: todayDate,
                    key: 'selection'
                }),
                isSelected() {
                    return compareRange(this.range());
                },

            },
            {
                label: 'Last 30 days',
                range: () => ({
                    startDate: moment().subtract(30, 'd').toDate(),
                    endDate: todayDate,
                    key: 'selection'
                }),
                isSelected() {
                    return compareRange(this.range());
                },

            },
            {
                label: 'Last 60 days',
                range: () => ({
                    startDate: moment().subtract(60, 'd').toDate(),
                    endDate: todayDate,
                    key: 'selection'
                }),
                isSelected() {
                    return compareRange(this.range());
                },

            },
            {
                label: 'Last 90 days',
                range: () => ({
                    startDate: moment().subtract(90, 'd').toDate(),
                    endDate: todayDate,
                    key: 'selection'
                }),
                isSelected() {
                    return compareRange(this.range());
                },

            },
            {
                label: 'Last 180 days',
                range: () => ({
                    startDate: moment().subtract(180, 'd').toDate(),
                    endDate: todayDate,
                    key: 'selection'
                }),
                isSelected() {
                    return compareRange(this.range());
                },

            },
            {
                label: 'Current Month',
                range: () => ({
                    startDate: startOfMonth(todayDate),
                    endDate: todayDate,
                    key: 'selection'
                }),
                isSelected() {
                    return compareRange(this.range());
                },

            },
            {
                label: 'Previous Month',
                range: () => ({
                    startDate: startOfMonth(addMonths(todayDate, -1)),
                    endDate: endOfMonth(addMonths(todayDate, -1)),
                    key: 'selection'
                }),
                isSelected() {
                    return compareRange(this.range());
                },

            },
            {
                label: 'Current Year',
                range: () => ({
                    startDate: startOfYear(todayDate),
                    endDate: todayDate,
                    key: 'selection'
                }),
                isSelected() {
                    return compareRange(this.range());
                },

            },
            {
                label: 'Last Year',
                range: () => ({
                    startDate: startOfYear(addYears(todayDate, -1)),
                    endDate: endOfYear(addYears(todayDate, -1)),
                    key: 'selection'
                }),
                isSelected() {
                    return compareRange(this.range());
                },

            },
        ];
        return ranges;
    }

    const handleClickOutside = event => {
        if (ref.current && !ref.current.contains(event.target)) {
            setOpenDatePicker(false);
        }
    };
    React.useEffect(() => {
        //document.addEventListener("keydown", handleHideDropdown, true);
        document.addEventListener("click", handleClickOutside, true);
        return () => {
            //  document.removeEventListener("keydown", handleHideDropdown, true);
            document.removeEventListener("click", handleClickOutside, true);
        };
    });

    const handleRangeChange = (ranges) => {

        if (ranges.selection.startDate !== ranges.selection.endDate) {
            setOpenDatePicker(false)
        }
        setRangeSelection(ranges.selection);

    }

    React.useEffect(() => {
        if (rangeSelection && rangeSelection.startDate) {
            props.handleDateChange(rangeSelection);
            const startDateString = rangeSelection.startDate ? moment(rangeSelection.startDate).format('MM-DD-YYYY') : '';
            const endDateString = rangeSelection.endDate ? moment(rangeSelection.endDate).format('MM-DD-YYYY') : '';
            setDateString(startDateString ? (startDateString + ' - ' + endDateString) : '');
        }
    }, [rangeSelection])

    const handleSearch = () => {
        props.handleSearch();
    }
    const resetSearch = () => {
        props.resetSearch();
    }

    return (
        <Row>
            {(props.children) && props.children}

            <Col lg={(props.lg)?props.lg:3} md={(props.md)?props.md:6} sm={(props.sm)?props.sm:6} xs={(props.xs)?props.xs:8} >
                <div ref={ref}>
                    {(props.label) && <div style={{ fontSize: 14 }}>{props.label}</div>}
                    <Input readOnly={true} placeholder={'Select Date range'} onFocus={() => {
                        if (!rangeSelection) {
                            setRangeSelection({
                                startDate: moment().toDate(),
                                endDate: moment().toDate(),
                                key: 'selection'
                            })
                        }
                        setOpenDatePicker(true)
                    }} value={dateString} />
                    {(openDatePicker) ? <DateRangePicker className='date-range-picker'
                        onChange={handleRangeChange}
                        ranges={[rangeSelection]}
                        startDatePlaceholder="Start: YYYY-MM-DD"
                        endDatePlaceholder="End: YYYY-MM-DD"
                        inputRanges={[]}
                        staticRanges={getDateRanges()}


                    /> : ''}
                </div>
            </Col>
            <Col lg={(props.blg)?props.blg:3} md={(props.bmd)?props.bmd:6} sm={(props.bsm)?props.bsm:6} xs={(props.bxs)?props.bxs:8}>
                {(props.label) && <div>&nbsp;</div>}
                <Button
                    color="primary"
                    style={(props.buttonStyle) ? props.buttonStyle : { padding: 'auto' }}
                    size="sm"
                    className="dashboard-search-btn"
                    onClick={handleSearch}
                    block >
                    Search
                </Button>
            </Col>
            {(props.resetButton) &&
                <Col>
                    {(props.label) && <div>&nbsp;</div>}
                    <Button
                        color="secondary"
                        style={(props.buttonStyle) ? props.buttonStyle : { padding: 'auto' }}
                        size="sm"
                        className="dashboard-search-btn"
                        onClick={resetSearch}
                        block >
                        Reset
                    </Button>
                </Col>
            }
        </Row>
    );
}

export default DateRangePickerComp;